import React, { Component } from 'react'
import { Modal } from 'hljd'
import { observer } from 'mobx-react'
import styles from './style.module.less'
import store from '../../store'
@observer
export default class extends Component {
  render() {
    const { protocolModalShow, protocolContent, protocolTitle } = store
    return (
      <Modal
        width={526}
        visible={protocolModalShow}
        title={protocolTitle}
        onCancel={store.toggleProtocolModal}
        afterClose={store.setProtocolModal}
        footer={null}
      >
        <div
          className={styles.content}
          dangerouslySetInnerHTML={{ __html: protocolContent }}
        />
      </Modal>
    )
  }
}
